import { useRef, useState } from "react";

export default function useVoiceChatRecorder(connection) {
    const audioContextRef = useRef(null);
    const sourceRef = useRef(null);
    const workletNodeRef = useRef(null);
    const streamRef = useRef(null);

    const [recording, setRecording] = useState(false);

    const startRecording = async () => {
        if (!connection || connection.state !== "Connected") return;
        streamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });

        audioContextRef.current = new AudioContext({ sampleRate: 16000 });
        await audioContextRef.current.audioWorklet.addModule("/pcm-worklet.js");

        sourceRef.current =
            audioContextRef.current.createMediaStreamSource(streamRef.current);

        workletNodeRef.current = new AudioWorkletNode(
            audioContextRef.current,
            "pcm-processor"
        );

        sourceRef.current.connect(workletNodeRef.current);

        workletNodeRef.current.port.onmessage = (e) => {
            if (connection.state !== "Connected") return;

            const pcm16 = new Uint8Array(e.data);
            const base64 = btoa(String.fromCharCode(...pcm16));
            connection.invoke("SendAudioChunk", base64);
        };

        setRecording(true);
    };

    const stopRecording = () => {
        workletNodeRef.current?.disconnect();
        sourceRef.current?.disconnect();
        streamRef.current?.getTracks().forEach(t => t.stop());
        audioContextRef.current?.close();
        setRecording(false);
    };

    return { recording, startRecording, stopRecording };
}
